export default __webpack_public_path__ + "static/media/people.65b9461c.svg";